import {
  CHANGE_SEARCHFIELD,
  REQUEST_USERS_PENDING,
  REQUEST_USERS_SUCCESS,
  REQUEST_USERS_FAILED,
  GET_USER_PROFILE,
  GET_USER_PROFILE_ERROR,
  CREATE_USER_PROFILE_SUCCESS,
  CREATE_USER_PROFILE_FAILED,
  CREATE_USER_PROFILE_PENDING,
  EDIT_USER_PROFILE_SUCCESS,
} from "../constants/userConstants";

const initialStateSearch = {
  searchField: "",
};

export const searchUsers = (state = initialStateSearch, action = {}) => {
  switch (action.type) {
    case CHANGE_SEARCHFIELD:
      return Object.assign({}, state, { searchField: action.payload });
    default:
      return state;
  }
};

const initialStateUsers = {
  users: [],
  isPending: true,
};

export const requestUsers = (state = initialStateUsers, action = {}) => {
  switch (action.type) {
    case REQUEST_USERS_PENDING:
      return Object.assign({}, state, { isPending: true });
    case REQUEST_USERS_SUCCESS:
      return Object.assign({}, state, {
        users: action.payload,
        isPending: false,
      });
    case REQUEST_USERS_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

const INITIAL_STATE = {
  uzer: [],
  loading: true,
};
export const uzer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USER_PROFILE:
      return {
        ...state,
        uzer: action.payload,
        loading: false,
      };
    case GET_USER_PROFILE_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const postUser = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case CREATE_USER_PROFILE_PENDING:
      return Object.assign({}, state, { loading: true });
    case CREATE_USER_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        uzer: action.payload,
      });
    case CREATE_USER_PROFILE_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};
export const editUserProfile = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case EDIT_USER_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        uzer: action.payload,
      });
    default:
      return state;
  }
};
